import { Suspense } from "react";
import { LazyLoadingAnimation } from "./Lazy";
import { JsonViewerProps, JsonViewer } from "@textea/json-viewer";
import { ErrorCatch } from './ErrorCatch';

const monokaiTheme = {
    scheme: 'monokai',
    author: 'wimer hazenberg (http://www.monokai.nl)',
    base00: '#272822',
    base01: '#383830',
    base02: '#49483e',
    base03: '#75715e',
    base04: '#a59f85',
    base05: '#f8f8f2',
    base06: '#f5f4f1',
    base07: '#ffffff',
    base08: '#f92672',
    base09: '#fd971f',
    base0A: '#f4bf75',
    base0B: '#a6e22e',
    base0C: '#a1efe4',
    base0D: '#66d9ef',
    base0E: '#ae81ff',
    base0F: '#cc6633',
};

export var ReactJsonView = (props: JsonViewerProps) => {
    var { style, ...extraProps } = props
    return (
        <ErrorCatch>
            <Suspense fallback={<LazyLoadingAnimation style={{ width: "100%", height: "100%", backgroundColor: "#1e1e1e" }} />}>
                <JsonViewer
                    displayDataTypes={false}
                    collapseStringsAfterLength={40}
                    enableClipboard
                    indentWidth={4}
                    defaultInspectDepth={1}
                    style={{ ...style, color: 'white' }}
                    theme={monokaiTheme}
                    {...extraProps} />
            </Suspense>
        </ErrorCatch>
    );
}